<template>
  <header>
    <div class="wrap">
      <router-link :to="{ name: 'home' }" class="logo">
        <img src="../assets/images/ceati-logo.png" alt="联盟" />
      </router-link>
      <ul class="list">
        <li :class="{ active: active === 'home' }">
          <router-link :to="{ name: 'home' }">首页</router-link>
        </li>
        <li :class="{ active: active === 'introuduce' }">
          <router-link :to="{ name: 'introuduce' }">联盟简介</router-link>
        </li>
        <li :class="{ active: active === 'regulations' }">
          <router-link :to="{ name: 'regulations' }">联盟章程</router-link>
        </li>
        <li :class="{ active: active === 'capability' }">
          <router-link :to="{ name: 'capability' }">联盟能力</router-link>
        </li>
        <li :class="{ active: active === 'members' }">
          <router-link :to="{ name: 'members' }">联盟成员</router-link>
        </li>
        <li :class="{ active: active === 'redownload' }">
          <router-link :to="{ name: 'redownload' }">资源下载</router-link>
        </li>
        <li :class="{ active: active === 'download' }">
          <a href="//downloads.ceati.org.cn" target="_blank">QTDE资源</a>
        </li>
      </ul>
      <div class="right">
        <router-link :to="{ name: 'join' }" class="join-us">
          <span>加入我们</span>
        </router-link>
        <div class="login-info">
          <template v-if="isLogin">
            <div class="user-wrap"  @mouseenter="handleOperation(true)" @mouseleave="handleOperation(false)">
              <img src="../assets/images/Icon/users.png" alt="加载失败" class="img" >
              <span class="user">{{formatNameLength(userinfo.username)}}</span>
              <div class="operation" v-clickoutside="handleClose" v-if="showOperate">
                <div class="operate" @click="handleEdit">编辑</div>
                <div class="operate" @click="handleQuit">退出</div>
              </div>
            </div>
          </template>
          <template v-else>
            <span class="login" >
              <router-link :to="{ name: 'login' }">登录</router-link>
            </span>
            <span class="regis" >
              <router-link :to="{ name: 'register' }">注册</router-link>
            </span>
          </template>
        </div>
        <!-- <div>
        </div> -->
      </div>
    </div>
  </header>
</template>

<script>
import { User } from '@/api/api'
export default {
  name: 'NavHeader',
  data () {
    return {
      active: '',
      showOperate: false,
      isLogin: false,
      userinfo: {}
    };
  },
  watch: {
    $route: function () {
      this.active = this.$route.name;
    }
  },
  created () {
    this.getUserInfo();
  },
  mounted () {
    this.active = this.$route.name;
  },
  methods: {
    handleQuit () {
      User.logout().then(({ data }) => {
        if ([10000, 10001].includes(data.status)) {
          this.isLogin = false;
          this.userinfo = {}
          sessionStorage.removeItem('user')
          this.$router.push('/')
          this.$nextTick(() => {
            this.showOperate = false;
          })
        }
      })
    },
    getUserInfo () {
      User.getUserInfo({ send_email: false }).then(({ data }) => {
        if (data.status === 10000) {
          this.isLogin = true;
          this.userinfo = data.data
          sessionStorage.setItem('user', JSON.stringify({ username: this.userinfo.username }))
        } else if (data.status === 10001) {
          // 10001  用户未登录
          this.isLogin = false;
          sessionStorage.removeItem('user')
        } else {
          this.$message.error(data.message)
        }
      })
    },
    handleOperation (isShow) {
      this.showOperate = isShow
    },
    formatNameLength (name) {
      if (!name) return '用户名'
      let result = ''
      if (name.length > 10) {
        result = name.substring(0, 10) + '...'
      } else {
        result = name
      }
      return result
    },
    handleClose () {
      this.showOperate = false;
    },
    handleEdit () {
      this.$router.push({ path: '/personalinfo',
        query: {
          t: Date.now()
        } })
      this.$nextTick(() => {
        this.showOperate = false;
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
header {
  height: 90px;
  line-height: 90px;
  background: #ffffff;
  position: fixed;
  width: 100%;
  z-index: 100;
  border-bottom: 1px solid;
  border-color: rgba($color: #333333, $alpha: 0.3);
  .wrap {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .logo {
    // float: left;
    // height: 54px;
    // position: relative;
    // top: 18px;
    line-height: 100%;
  }
  .list {
    // float: left;
    // margin-left: 94px;
    width: 600px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    // flex:1;
    li {
      // float: left;
      // margin-right: 60px;
      a {
        font-size: 16px;
        color: #333333;
        text-decoration: none;
        font-weight: bold;
      }
    }
    .active {
      a {
        border-bottom: 3px solid #0044cc;
        padding-bottom: 4px;
        color: #0044cc;
      }
    }
  }
  .right{
    display: flex;
    align-items: center;
    flex:0;
    .login-info{
      display: inline-flex;
      padding-left:20px;
      width: 125px;
      justify-content: left;
      align-items: center;
      position: relative;
      .user-wrap{
        display: flex;
        justify-content: left;
        align-items: center;
      }
      .regis,.user{
        padding-left: 10px;
      }
      .user{
        white-space: nowrap;
        font-size: 14px;
        line-height: 3.5em;
      }
      .img{
        width: 30px;
        height: 30px;
      }
      .user,.img{
        cursor: pointer;
      }
      .operation{
        position: absolute;
        bottom: -45px;
        left: 55px;
        width: 100px;
        height: 50px;
        background: #fff;
        box-shadow: 0 0 3px rgba(0,0,0,0.2);
        .operate{
          line-height: 24px;
          font-size: 14px;
          text-align: left;
          padding-left: 10px;
          border-bottom: solid 1px #ccc;
          cursor: pointer;
          &:last-child{
            // color: red;
            border-bottom: none;
          }
          &:hover{
            // color: #fff;
            background: rgba($color: #000000, $alpha: 0.1);
          }
        }
      }
      .login , .regis{
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        &:hover{
          color: #409EFF;
        }
      }
    }

  }
  .join-us {
    width: 104px;
    height: 36px;
    // background-color: #0044CC;
    background: #0044cc;
    font-size: 14px;
    color: #ffffff;
    line-height: 36px;
    // float: right;
    text-decoration: none;
    // position: relative;
    // top: 24px;
    width: 104px;
    height: 36px;
    text-align: center;
    span {
      background: url(~@/assets/images/join-us.png) no-repeat center right;
      line-height: 36px;
      padding-right: 17px;
      background-position-y: 2px;
    }
  }
}
</style>
